import { render, staticRenderFns } from "./rechargeRecord.vue?vue&type=template&id=54865b2e&scoped=true"
import script from "./rechargeRecord.vue?vue&type=script&lang=js"
export * from "./rechargeRecord.vue?vue&type=script&lang=js"
import style0 from "./rechargeRecord.vue?vue&type=style&index=0&id=54865b2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54865b2e",
  null
  
)

export default component.exports